<footer class="footer">

  <div class="footer__main">
    <div class="row content">
      <div class="col col--033 footer__col footer__main--head">

        <svg class="footer__logo"
             viewBox="0 0 111 39.96">
          <use xlink:href="#ab-logo"></use>
        </svg>
        <!--
        <p>
          Action Network is an open platform that empowers individuals and groups
          to organize for progressive causes. We encourage responsible activism,
          and do not support using the platform to take unlawful or other improper
          action. We do not control or endorse the conduct of users and make no
          representations of any kind about them.
        </p>
        -->
        <button class="close-footer-btn d-none--on-old"
                (click)="hideFooter()"><i class="far fa-xmark color--red"></i></button>
      </div>

      <div class="col col--067 footer__main--scrollable">
        <div class="col col--033 footer__col mb-0250">

          <div class="row">
            <section>
              <p>Action Builder is an organizing toolset built with organizers for organizers
                through a deeply cooperative process with the AFL-CIO.</p>
              <p>Learn more about using Action Builder with our
                <a href="https://actionbuilder.zendesk.com/hc/en-us" target="_blank">help articles</a>
                and <a href="https://www.youtube.com/@BuildPower/videos" target="_blank">video tutorials</a>.</p>
              <p>Maps powered by <a href="https://mapbox.com/" target="_blank">Mapbox</a>.</p>
            </section>
          </div>
        </div>

        <div class="col col--067 footer__col">
          <section>
            <h4>Get Field Notes</h4>
            <p>Get and stay in the know by
              <a href="https://actionnetwork.org/forms/action-builder-news/"
                 target="_blank">joining our email list</a> to receive content related to Action Builder and the
              organizers we support!</p>
            <h4 class="mt-0250">Still Have Questions?</h4>
            <p>Check out our <a href="https://actionbuilder.org/docs/v1/index.html"
                                target="_blank">API Documentation</a> and
              <a href="https://actionbuilder.org/mirror/index.html"
                 target="_blank">SQL Mirror Documentation</a> for
              <a href="https://actionbuilder.org/developers"
                 target="_blank">Developers</a></p>
            <p>Read our <a href="https://actionbuilder.zendesk.com/hc/en-us/articles/360043814451"
                           target="_blank">Privacy Notice</a>,
              <a href="https://actionbuilder.zendesk.com/hc/en-us/articles/360043814731"
                 target="_blank">Cookies Notice</a>,
              <a href="https://actionbuilder.zendesk.com/hc/en-us/articles/22116859197460"
                 target="_blank">Terms of Service</a>,
              <a href="https://actionbuilder.zendesk.com/hc/en-us/articles/360043375272"
                 target="_blank">Acceptable Use Policy</a>, and
              <a href="https://actionbuilder.zendesk.com/hc/en-us/articles/35004779511828"
                 target="_blank">Data Processing Terms</a></p>
          </section>
        </div>
      </div>
    </div>
  </div>
  <div class="footer__bg"
       (click)="hideFooter()"></div>
</footer>
